import React from 'react'

import { WidgetComponent } from 'features/views/LayoutEditor/types'

import { Box } from 'ui/components/Box'

import { useCustomCodeWidgetState } from './hooks/useCustomCodeWidgetState'
import { CustomCodeWidgetType } from './types'

type CustomCodeWidgetProps = {}

const CustomCodeWidgetComponent: WidgetComponent<CustomCodeWidgetType, CustomCodeWidgetProps> = ({
    widget,
    isEditing,
}) => {
    const { code, isLoading, elementRef } = useCustomCodeWidgetState(widget)

    if (isLoading && !isEditing) return null
    if (!code && !isEditing) return null

    return <Box ref={elementRef} minHeight={isEditing ? '100px' : undefined} position="relative" />
}

export const CustomCodeWidget = React.memo(CustomCodeWidgetComponent)
